import { Injectable } from '@angular/core';
import { ResourceError } from "../resource/ResourceError";
import { ErrorTracingService } from "../error-tracing/error-tracing.service";

@Injectable({
  providedIn: 'root'
})
export class SentryService {

  constructor(private readonly errorTracingService: ErrorTracingService) { }

  public logDataSentryError(data: any, message: string = 'Log data sentry error'): void {
    const resourceError: ResourceError = new ResourceError(555, message, data);
    this.errorTracingService.captureException(resourceError);
  }
}
